import { Timer } from '#app/components/countdownTimer/countdownTimer.tsx'

interface FormSubmittingProps {
	isBusy: string
	isTransitioning: boolean
}

export const FormSubmitting = ({
	isBusy,
	isTransitioning,
}: FormSubmittingProps) => {
	if (isBusy !== 'submitting') {
		return null
	}

	return (
		<div
			className={`my-5 flex flex-col items-center justify-center gap-2 font-bold text-primary-400 md:min-h-[40vh] ${
				isTransitioning ? 'opacity-0' : ''
			}`}
		>
			<Timer />
		</div>
	)
}
